import {
  HStack,
  Stack,
  RadioGroup,
  useRadioGroup,
  VStack,
  Radio,
  useTheme,
  Text,
} from '@chakra-ui/react';
import RadioInput from './RadioInput';

interface RadioGroupInputProps {
  options: {
    value: string;
    label: string;
  }[];
  onChange: (e: any) => void;
  value: string;
}

export function RadioGroupInput({
  options,
  onChange,
  value,
}: RadioGroupInputProps) {
  const { colors } = useTheme();
  return (
    <RadioGroup onChange={onChange} value={value}>
      <Stack direction="column">
        {options.map((option) => {
          return (
            <Radio value={option.value}>
              <Text
                fontSize={'sm'}
                color={colors.text.secondary}
                fontWeight={'normal'}
              >
                {option.label}
              </Text>
            </Radio>
          );
        })}
      </Stack>
    </RadioGroup>
  );
}

export default RadioGroupInput;
